import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { SettingDefinition } from '../../../models/setting-definition';
import { Observable } from 'rxjs';
import { selectEditableSettings } from '../../../store/profile/profile.state';
import { SettingControlComponent } from '../setting-control/setting-control.component';
import { AsyncPipe } from '@angular/common';
import { MatTabGroup, MatTab } from '@angular/material/tabs';

@Component({
    selector: 'app-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['./settings-page.component.scss'],
    imports: [MatTabGroup, MatTab, SettingControlComponent, AsyncPipe]
})
export class SettingsPageComponent implements OnInit {

  constructor(private store: Store<AppState>) { }

  settingsDefaults$: Observable<SettingDefinition[]> = this.store.select(selectEditableSettings('defaults'));
  settingsPreferences$: Observable<SettingDefinition[]> = this.store.select(selectEditableSettings('preferences'));

  ngOnInit(): void {
  }

}
